// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
  apiKey: "AIzaSyCMA7L6flk-xQIpsRiIKFyLoVrjHeBytxs",
    authDomain: "greenproj-2b540.firebaseapp.com",
    projectId: "greenproj-2b540",
    storageBucket: "greenproj-2b540.appspot.com",
    messagingSenderId: "1029152821465",
    appId: "1:1029152821465:web:7ff397a245b6f785a5eec8"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
